// Started at module evaluation so the chunk downloads alongside the other plugins' rather than after them.
const vueDomPurifyHtmlPromise = import('vue-dompurify-html')

export default defineNuxtPlugin(async (nuxtApp) => {
  const VueDOMPurifyHTML = await vueDomPurifyHtmlPromise.then((mod) => mod.default)
  nuxtApp.vueApp.use(VueDOMPurifyHTML, {
    default: {
      ADD_TAGS: ['iframe'],
      FORCE_BODY: true,
    },
  })
})
